import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { IonicModule } from "@ionic/angular";
import { PipesModule } from "../pipes/pipes.module";
import { PopoverContentComponent } from "./popover-content/popover-content.component";
import { PopoverIframeComponent } from "./popover-iframe/popover-iframe.component";
import { PopoverSessionStatsComponent } from "./popover-session-stats/popover-session-stats.component";
import { PopoverReconfirmationComponent } from "./popover-reconfirmation/popover-reconfirmation.component";
import { PopoverPreGeoInfoComponent } from "./popover-pre-geo-info/popover-pre-geo-info.component";
import { PopoverSelfExcludeComponent } from "./popover-self-exclude/popover-self-exclude.component";
import { VipTermsComponent } from "./popover-vipterms/popover-vipterms.component";
import { PopoverAlertComponent } from "./popover-alert/popover-alert.component";
import { ComponentsModule } from "../components/components.module";
import { PopoverStandardConfirmComponent } from "./popover-standard-confirm/popover-standard-confirm.component";
import { PopoveApprateComponent } from "./popover-apprate/popover-apprate.component";
import { PopoverWebviewComponent } from "./popover-webview/popover-webview/popover-webview.component";
import { PopoverGameHistoryDetailsComponent } from "./popover-game-history-details/popover-game-history-details.component";
import { PopoverMarketingComponent } from "./popover-marketing/popover-marketing.component";
import { PopoverAgreementComponent } from "./popover-agreement/popover-agreement.component";
import { PopoverDarkWebviewComponent } from "./popover-webview/popover-dark-webview/popover-dark-webview.component";
import { BehalfDeclarationPopover } from "./behalf-declaration/behalf-declaration";
import { PopoverAvailableGamesComponent } from "./popover-available-games/popover-available-games.component";
import { RestrictedMoneyPopover } from "./popover-restricted-money/restricted-money";
import { DateETPipe } from "../pipes/date-format-et.pipe";

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    BrowserModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    ComponentsModule,
    DateETPipe
  ],
  declarations: [
    VipTermsComponent,
    PopoverAlertComponent,
    PopoverIframeComponent,
    PopoverContentComponent,
    PopoverSessionStatsComponent,
    PopoverReconfirmationComponent,
    PopoverAvailableGamesComponent,
    PopoverPreGeoInfoComponent,
    PopoverSelfExcludeComponent,
    PopoverStandardConfirmComponent,
    BehalfDeclarationPopover,
    PopoverDarkWebviewComponent,
    PopoverWebviewComponent,
    PopoverGameHistoryDetailsComponent,
    PopoverMarketingComponent,
    PopoveApprateComponent,
    PopoverAgreementComponent,
    RestrictedMoneyPopover
  ],
  exports: [
  ]
})

export class PopoverModule { }